<template>
  <b-card>
    <validation-observer ref="companyDataForm">
      <b-form ref="companyDataFormElement" @submit.prevent="save">
        <b-row>
          <b-col cols="12">
            <b-form-group :label="t('Name')" label-for="name">
              <validation-provider #default="{ errors }" :name="t('Name')" vid="name">
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="name"
                    v-model="values.name"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                    :placeholder="t('Name')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="t('Authorized Name Surname')" label-for="Authorized Name Surname">
              <validation-provider
                #default="{ errors }"
                :name="t('Authorized Name Surname')"
                vid="Authorized Name Surname"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="authorized_name_surname"
                    v-model="values.authorizedName"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                    type="text"
                    :placeholder="t('Authorized Name Surname')"
                    @keypress="isLetter($event)"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="t('Authorized No')" label-for="Authorized No">
              <validation-provider
                #default="{ errors }"
                :name="t('Authorized No')"
                vid="Authorized No"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="authorized_no"
                    v-model="values.authorizedNo"
                    type="number"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                    :placeholder="t('Authorized No')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="t('Email')" label-for="email">
              <validation-provider #default="{ errors }" :name="t('Email')" vid="email">
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="email_company_data"
                    v-model="values.email"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                    :placeholder="t('Email')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="t('Phone')" label-for="phone">
              <validation-provider #default="{ errors }" :name="t('Phone')" vid="phone">
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="phone"
                    v-model="values.phone"
                    type="number"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="name"
                    :placeholder="t('Phone')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              type="submit"
              :disabled="requestIsLoading"
            >
              {{ requestIsLoading ? t('Loading') : t('Save Changes') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import {
  BInputGroup,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BCard,
  BRow
} from 'bootstrap-vue';
import { helper } from '@core/mixins/helper.js';
import Ripple from 'vue-ripple-directive';
import useService from '@/auth/service/useService';

export default {
  directives: {
    Ripple
  },

  components: {
    BInputGroup,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BCard,

    BRow,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [helper],

  data() {
    return {
      values: {},
      requestIsLoading: false
    };
  },

  created() {
    this.accountCompanyData();
  },

  methods: {
    formatTaxNumber(e) {
      return String(e).substring(0, 10);
    },

    save() {
      const { email } = this.values;

      if (this.validateEmail(email)) {
        this.$refs.companyDataForm.validate().then(success => {
          if (success) {
            this.requestIsLoading = true;

            const payload = {
              name: this.values.name,
              authorizedName: this.values.authorizedName ?? this.values.authorized_name,
              authorizedNo: this.values.authorizedNo ?? this.values.authorized_no,
              email: this.values.email,
              phone: this.values.phone
            };

            useService
              .updateAccountCompanyInfos(payload)
              .then(response => {
                this.$refs.companyDataForm.reset();
                this.showSuccessMessage(response.message);
              })
              .catch(messages => {
                if (typeof messages === 'object' && messages && messages.length) {
                  messages.forEach(item => {
                    this.showErrorMessage(item.message);
                  });
                }
              })
              .finally(() => {
                this.requestIsLoading = false;
              });
          }
        });
      } else {
        const a = this.$i18n.locale;
        this.showErrorMessage(
          a === 'en'
            ? 'Please enter a valid email address.'
            : 'Lütfen geçerli bir email adresi giriniz.'
        );
        return false;
      }

      return true;
    },

    accountCompanyData() {
      useService.getAccountCompanyInfos().then(response => {
        this.values = response.data;
        delete this.values.type;
      });
    },

    isLetter(event) {
      const char = String.fromCharCode(event.keyCode);

      if (/^[A-Za-z]+$/.test(char)) {
        return true;
      }

      event.preventDefault();
      return false;
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
